import React from 'react'
import { Route, Switch, Redirect } from 'react-router-dom'

import { AccountActivated, SignupVerify } from 'components/account'
import Signup from 'views/Home/Signup'

// eslint-disable-next-line react/display-name
export default ({ match }) => (
  <Switch>
    <Route exact path={`${match.path}/`} render={() => (
      // Desactivado por cierre de nixi1
      // <Signup {...props} actionRegister='owner' />
      <Redirect to='/login' />
    )} />
    <Route exact path={`${match.path}/operator/:token`} render={(props) => (
      <Signup {...props} actionRegister='operator' />
    )} />
    <Route exact path={`${match.path}/success`} component={AccountActivated} />
    <Route exact path={`${match.path}/verify/:token`} component={SignupVerify} />
  </Switch>
)
